<template>
    <v-row justify="center">
        <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                >
                    Update rates
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Update Rates</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row >
                            <v-col v-for="currency in currencies" :key="currency"
                                    cols="12"
                                    sm="6"
                                    md="4"
                            >
                                <v-text-field
                                        :label="currency"
                                        type="number"
                                        step="0.01"
                                        required
                                        v-model="form[currency]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                    >
                        Close
                    </v-btn>
                    <v-btn
                            color="blue darken-1"
                            text
                            @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        props: {
            rates: {
                type: Object
            }
        },

        data: () => ({
            currencies: ['EUR', 'BRL', 'GBP'],
            form: {},
            dialog: false,
        }),

        async mounted() {
            this.form[this.currencies[0]] = this.rates.eur;
            this.form[this.currencies[1]] = this.rates.brl;
            this.form[this.currencies[2]] = this.rates.gbp;

        },

        methods: {
            save(){
                this.dialog = false;
                this.$emit('save', this.form);
            }
        }
    }
</script>